module.exports = __webpack_public_path__ + "img/alert-bg.ceefff57.png";